import { getBeeswaxAccountAudience } from "@/apis/v1/audience";
import mapFilterQueryKeys from "@/utils/mapFilterQueryKeys";
import { useQuery } from "@tanstack/react-query";
export const GET_MERGE_AUDIENCE_KEY = (keys?: unknown[]) => [
  "audiences",
  "account",
  "get",
  ...mapFilterQueryKeys(keys),
];

export function useBeeswaxAccountAudienceList({
  enabled = true,
  queryParams,
}: {
  enabled?: boolean;
  queryParams?: {
    advertiserId?: string | number;
    status?: string;
  };
} = {}) {
  return useQuery(
    ["audiences", "display", "account", "get"],
    getBeeswaxAccountAudience,
    {
      enabled,
      meta: {
        queryParams,
      },
    }
  );
}
